import React, { useRef, useEffect, useState } from "react";
import useTestimonial from './useTestimonial';
import { Link } from "react-router-dom";

const Testimonial = () => {


  return (
    <section className="position-relative stop-gues">
      <h2 className="hero-heading">Stop Guessing.</h2>
        <h2 className="hero-heading">Start Growing.</h2>
        <p className="hero-sub-text  mt-3 mb-3">Discover where your sales leak and fix them today.</p>
        <button className="btn hero-btn px-4 py-3 mt-4  me-3"><Link to={"/signin"} className='text-decoration-none'>Reveal My Growth Gaps </Link></button>

    </section>
  );
};

export default Testimonial;
